import { removeLocalStorage } from '@/utils/clientStorage'

export const decodeToken = (token?: string | null, isServer = false) => {
  if (!token) return {}
  try {
    const base64Url = token.split('.')[1] as string
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    let jsonPayload
    if (isServer) {
      jsonPayload = Buffer.from(
        token.split('.')[1] as string,
        'base64',
      ).toString()
    } else {
      jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
          })
          .join(''),
      )
    }

    return JSON.parse(jsonPayload)
  } catch (e) {
    if (!isServer) {
      // remove error token to avoid shop will process that token again when user refresh shop
      // Guarded: `window.localStorage` throws on access in Safari with "Block
      // All Cookies", and throwing from inside this catch would escape
      // decodeToken entirely — turning a malformed token into a crash on every
      // caller, several of which run during render.
      removeLocalStorage('accessToken')
    }
    return {}
  }
}
